import { render, staticRenderFns } from "./EmployeeLogs.vue?vue&type=template&id=62387934"
import script from "./EmployeeLogs.vue?vue&type=script&lang=js"
export * from "./EmployeeLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports